import { useState } from 'react';

import type { UploadFile } from '@/types/uploadFile';

export function useChatAttachments() {
  const [files, setFiles] = useState<UploadFile[]>([]);

  const [noPHIConfirmed, setNoPHIConfirmed] = useState(false);

  const hasFiles = files.length > 0;

  const canSendWithFiles = !hasFiles || noPHIConfirmed;

  const resetAttachments = () => {
    setFiles([]);

    setNoPHIConfirmed(false);
  };

  return {
    files,
    setFiles,
    noPHIConfirmed,
    setNoPHIConfirmed,
    hasFiles,
    canSendWithFiles,
    resetAttachments,
  };
}
